import { useTheme } from '@mui/material';

export const useSxStyles = () => {
  const theme = useTheme();

  return {
    tabFieldSet: {
      width: theme.spacing(40),
      padding: theme.spacing(1, 2),
    },
    tabContent: {
      display: 'flex',
      gap: theme.spacing(1),
      flexDirection: 'column',
    },
  };
};
